import { useMsal } from "@azure/msal-react";
import React, { useContext, useState, useEffect } from "react";
import { Root, Tittle, Content, Column, Field, FieldInfo } from "./style";
import { useTranslation } from "react-i18next";
import ModalPersonalDataPolicy from "../../../PersonalDataPolicy";
import Wait from "../../../Wait";
import { ContactContext } from "../../../../context/contact/ContactContext";

const Information = () => {
  const { accounts } = useMsal();
  const { t } = useTranslation();
  const { personalData, getPersonalData, getContactInformation } =
    useContext(ContactContext);
  const [open, setOpen] = useState(false);
  const [contactInfo, setcontactInfo] = useState({});

  useEffect(() => {
    const fetchData2 = async () => {
      await getPersonalData();
      setcontactInfo(await getContactInformation(accounts[0].localAccountId));
    };
    fetchData2();
  }, []);

  useEffect(() => {
    if (Object.keys(personalData).length !== 0) {
      setOpen(personalData.acceptedAgreements === 0);
    } else {
      setOpen(true);
    }
  }, [personalData]);

  return (
    <Root>
      {Object.keys(contactInfo).length === 0 ? (
        <Wait />
      ) : (
        <>
          <ModalPersonalDataPolicy open={open} setOpen={setOpen} />
          <Tittle>{t("myInformation")}</Tittle>
          <br />
          <Content>
            <Column>
              <Field>{t("name")}</Field>
              <FieldInfo>{contactInfo.givenName}</FieldInfo>
              <Field>{t("email")}</Field>
              <FieldInfo>{accounts[0].idTokenClaims.emails[0]}</FieldInfo>
            </Column>
            <Column>
              <Field>{t("lastName")}</Field>
              <FieldInfo>{contactInfo.surname}</FieldInfo>
              <Field>{t("user") + " ID"}</Field>
              <FieldInfo>{accounts[0].username}</FieldInfo>
            </Column>
          </Content>
        </>
      )}
    </Root>
  );
};

export default Information;
